import { render, staticRenderFns } from "./NotFoundLayout.vue?vue&type=template&id=ba3fc158&scoped=true&"
import script from "./NotFoundLayout.vue?vue&type=script&lang=js&"
export * from "./NotFoundLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba3fc158",
  null
  
)

export default component.exports